import { Box, Typography } from '@mui/material'

const SectionTitle = ({ title, subtitle }: { title: string; subtitle: string }) => (
  <Box>
    <Typography fontSize="20px" fontWeight={500}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" fontSize="13px">
      {subtitle}
    </Typography>
  </Box>
)

export default SectionTitle
